import { ErrorHandler, Injectable } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar'

import { AsiakkaanTuote } from '@lemon/core-firebase/model/lasku'

import { firstValueFrom } from 'rxjs'

import { LaskuService } from '../../_angular/service/lasku/lasku.service'
import { LadataanService } from '../../_jaettu-angular/service/ladataan.service'
import { LemonTranslationService } from '../../_jaettu-angular/service/lemon-translation.service'
import { TuoteDialog, TuoteDialogData } from './tuote.dialog'

@Injectable()
export class TuoteDialogiService {
  constructor(
    private _dialog: MatDialog,
    private _laskuService: LaskuService,
    private _ladataanService: LadataanService,
    private _errorHandler: ErrorHandler,
    private _snackbar: MatSnackBar,
    private _translationService: LemonTranslationService,
  ) {}

  /** Palauttaa true, jos tuote tallennettiin tai poistettiin. */
  async avaaTuoterekisterinTuote(tuote: AsiakkaanTuote | null): Promise<boolean> {
    const data: TuoteDialogData = { tuote }
    const tulos = await firstValueFrom(this._dialog.open<TuoteDialog, TuoteDialogData, AsiakkaanTuote | 'poistettu'>(TuoteDialog, { data, width: '560px' }).afterClosed())
    if (!tulos) {
      return false
    }
    if (tulos === 'poistettu') {
      return true
    }

    this._ladataanService.aloitaLataaminen()
    try {
      await this._laskuService.updateTuotteet([tulos])
      return true
    } catch (err) {
      this._errorHandler.handleError(err)
      this._snackbar.open(this._translationService.lokalisoi('tuote.tallennus-epaonnistui'), 'OK', { duration: 10000, verticalPosition: 'top' })
      return false
    } finally {
      this._ladataanService.lopetaLataaminen()
    }
  }
}
